import { render, staticRenderFns } from "./NoDataWrapper.vue?vue&type=template&id=56258662&scoped=true&"
import script from "./NoDataWrapper.vue?vue&type=script&lang=js&"
export * from "./NoDataWrapper.vue?vue&type=script&lang=js&"
import style0 from "./NoDataWrapper.vue?vue&type=style&index=0&id=56258662&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56258662",
  null
  
)

/* custom blocks */
import block0 from "./NoDataWrapper.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56258662')) {
      api.createRecord('56258662', component.options)
    } else {
      api.reload('56258662', component.options)
    }
    module.hot.accept("./NoDataWrapper.vue?vue&type=template&id=56258662&scoped=true&", function () {
      api.rerender('56258662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Dashboard/NoDataWrapper.vue"
export default component.exports